"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _piShuffles = _interopRequireDefault(require("./pi-shuffles"));

var _rhoOffsets = _interopRequireDefault(require("./rho-offsets"));

var _copy = _interopRequireDefault(require("../copy"));

var _rotate = _interopRequireDefault(require("../rotate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var rhoPi = function rhoPi(_ref) {
  var A = _ref.A,
      C = _ref.C,
      W = _ref.W;
  (0, _copy.default)(A, 1)(W, 0);

  for (var i = 0; i < 24; i++) {
    var j = _piShuffles.default[i];
    var r = _rhoOffsets.default[i];
    (0, _copy.default)(A, j)(C, 0);
    (0, _copy.default)((0, _rotate.default)(W, r), 0)(A, j);
    (0, _copy.default)(C, 0)(W, 0);
  }
};

var _default = rhoPi;
exports.default = _default;